import * as APIRoutes from '@mm/api-routes';
import { buildQueryString } from '@mm/utils';
import {
  ExtendedSponsoredMessageModel,
  SponsoredMessageModel,
} from '../model/SponsoredMessageModel';
import { Pagination } from '../store-interfaces';
import AuthenticatedController from './AuthenticatedController';
import AudiencesModel from '../model/AudiencesModel';

export type RetrieveAllResponse = {
  sponsoredMessages: SponsoredMessageModel[];
  pagination: Pagination;
};

type SponsoredMessageResponse = {
  success: boolean;
  errors: string[];
  sponsoredMessage: SponsoredMessageModel;
};

type PublishResponse = SponsoredMessageResponse & {
  adAudience?: AudiencesModel;
};

type RetrieveAllOptions = {
  page?: number;
  perPage?: number;
  orderBy?: string;
  orderDirection?: 'asc' | 'desc';
};

export default class SponsoredMessageController extends AuthenticatedController {
  static async retrieveAll(
    botId: number,
    options?: RetrieveAllOptions,
  ): Promise<RetrieveAllResponse> {
    const queryString = buildQueryString({
      per_page: options?.perPage,
      page: options?.page,
      order_by: options?.orderBy,
      order_direction: options?.orderDirection,
    });

    return super.get(`${APIRoutes.SPONSORED_MESSAGES(botId)}/${queryString}`);
  }

  static async retrieveById(
    botId: number,
    sponsoredMessageId: number,
  ): Promise<SponsoredMessageModel> {
    return super.get(
      `${APIRoutes.SPONSORED_MESSAGES(botId)}/${sponsoredMessageId}`,
    );
  }

  static deleteSponsoredMessage(botId: number, sponsoredMessageid: number) {
    return super.delete(
      `${APIRoutes.SPONSORED_MESSAGES(botId)}/${sponsoredMessageid}`,
    );
  }

  static prepareReplacementPage(
    botId: number,
    entityId: number,
    pageId?: number,
  ) {
    return super.post(
      APIRoutes.SPONSORED_MESSAGES_REPLACEMENT_PAGE(botId, entityId),
      {
        pageId,
      },
    );
  }

  static async putSponsoredMessage(
    botId: number,
    sponsoredMessageId: number,
    params: Partial<ExtendedSponsoredMessageModel>,
  ): Promise<SponsoredMessageResponse> {
    return super.put(
      `${APIRoutes.SPONSORED_MESSAGES(botId)}/${sponsoredMessageId}`,
      params,
    );
  }

  static async publish(
    botId: number,
    sponsoredMessageId: number,
    changes: Partial<SponsoredMessageModel>,
  ): Promise<PublishResponse> {
    return super.post(
      `${APIRoutes.SPONSORED_MESSAGES(botId)}/${sponsoredMessageId}/publish`,
      changes,
    );
  }

  static async postSponsoredMessage(
    botId: number,
    params: Partial<ExtendedSponsoredMessageModel>,
  ): Promise<SponsoredMessageResponse> {
    return super.post(APIRoutes.SPONSORED_MESSAGES(botId), params);
  }
}
